//import * as util from './util.js'
// react-ga
import * as log from './appLogger';
import { Config } from '../../data/Config';
import GTM from 'react-gtm-module';

function isEnabled() {
	return Config.enableGTM;
}

export function initGTM() {
	if (!isEnabled()) return;
	log.it('GTM', 'initGTM');
	const tagManagerArgs = {
		gtmId: Config.GTM_ID,
	};
	GTM.initialize(tagManagerArgs);
}

export function logPage(name: string) {
	if (!isEnabled()) return;
	log.it('GTM', 'logPage');
	/*
    const test = {
        dataLayer: {
            userId: '001',
            userProject: 'project',
            page: 'home'
        },
        dataLayerName: 'PageDataLayer'
    }
    GTM.dataLayer(test)*/
}

export function push(dataLayerJson: any) {
	if (!isEnabled()) return;
	log.ot('GTM DataLayer', dataLayerJson);
	GTM.dataLayer(dataLayerJson);
}
